module.exports = __webpack_public_path__ + "static/img/content13.7b74fd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/content13.png
// module id = slb7
// module chunks = 1 3